<template>
  <div id="ylInvestSystem">
    <ylInvestSystemMobile v-if="isMobileScreen" v-bind="$attrs" :list="list" />
    <ylInvestSystemPC v-else v-bind="$attrs" :list="list" />
  </div>
</template>
<script>
export default {
  name: "ylInvestSystem",
  components: {
    ylInvestSystemMobile: () => import("./components/mobile.vue"),
    ylInvestSystemPC: () => import("./components/pc.vue"),
  },
  data() {
    return {
      list: [],
    };
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() {
    this.investmentSystem();
  },
  methods: {
    async investmentSystem() {
      let res = await this.$api.investmentSystem();
      this.list = res;
    },
  },
};
</script>